import { stat } from 'fs';
import {
  login, loginStep2, logout, getInfo, refresh, getCsrfToken,
} from '../../api/user';
import {
  getAccessToken, setAccessToken, removeAccessToken,
  setAccountIndex, getAccountIndex, removeAccountIndex,
  getActiveModel, setActiveModel, getLoginTypeId,
  setLoginTypeId, getTempToken, setTempToken, removeTempToken,
  removeLoginTypeId, setProductList, removeProductList, removeActiveModel,
} from '../../utils/auth';

const state = {
  accessToken: getAccessToken(),
  // refreshToken: getRefreshToken(),
  name: '',
  roleIds: '',
  upiEnableDynamicQR:false,
  enableAutocomplete:false,
  loginId: '',
  accountId: '',
  isCusEnabled: false,
  cusLabelId: '',
  cusLabelName: '',
  isCollectAmount: false,
  refCount: 0,
  settlementTypeId: 1,
  isLoading: false,
  
  isOnDemandSettlementFile: false,
  isPayoutv2File: false,
  defaultMonth: '',
  policy:'',
  accountNames: [],
  accountIndex: getAccountIndex(),
  activeModelCode: getActiveModel(), // 1 - collect, 2 - OnDemandSettlement
  disableMonths: {},
  csrfToken: '',
  loginTypeId: getLoginTypeId(),
  tempToken: getTempToken(),
  productList: [],
  marketApi: false,
  ccmsType:"",
  bbpsBouKey1Label:"",
  billerTypeId:""
};

const mutations = {
  SET_ACCESS_TOKEN: (state, token) => {
    state.accessToken = token;
  },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_ROLE: (state, roleIds) => {
    state.roleIds = roleIds;
  },
  SET_DYNAMICQR: (state, upiEnableDynamicQR) => {
    state.upiEnableDynamicQR = upiEnableDynamicQR;
  },
  SET_AUTOCOMPLETE: (state, enableAutocomplete) => {
    state.enableAutocomplete = enableAutocomplete;
  },
  SET_LOGINID: (state, loginId) => {
    state.loginId = loginId;
  },
  SET_ACCOUNTID: (state, accountId) => {
    state.accountId = accountId;
  },
  SET_ISCUSENABLED: (state, isCusEnabled) => {
    state.isCusEnabled = isCusEnabled;
  },
  SET_CUSLABELID: (state, cusLabelId) => {
    state.cusLabelId = cusLabelId;
  },
  SET_CUSLABELNAME: (state, cusLabelName) => {
    state.cusLabelName = cusLabelName;
  },
  SET_DEFAULTMONTH: (state, defaultMonth) => {
    state.defaultMonth = defaultMonth;
  },
  SET_POLICY: (state, policy) => {
    state.policy = policy;
  },
  SET_DISABLEMONTHS: (state, disableMonths) => {
    state.disableMonths = disableMonths;
  },
  SET_ISAMOUNT: (state, isCollectAmount) => {
    state.isCollectAmount = isCollectAmount;
  },
  SET_SETTLEMENT_TYPEID: (state, settlementTypeId) => {
    state.settlementTypeId = settlementTypeId;
  },
  SET_ACCOUNTNAMES: (state, accountNames) => {
    state.accountNames = accountNames;
  },
  SET_ACCOUNTINDEX: (state, accountIndex) => {
    state.accountIndex = accountIndex;
  },
  SET_ISONDEMANDSETTLEMENTFILE: (state, isOnDemandSettlementFile) => {
    state.isOnDemandSettlementFile = isOnDemandSettlementFile;
  },
  SET_ISPAYOUTV2FILE: (state, isPayoutv2File) => {
    state.isPayoutv2File = isPayoutv2File;
  },
  SET_ACTIVE_MODEL_CODE: (state, activeModelCode) => {
    state.activeModelCode = activeModelCode;
  },
  SET_CSRF_TOKEN: (state, csrfToken) => {
    state.csrfToken = csrfToken;
  },
  SET_LOGIN_TYPEID: (state, loginTypeId) => {
    state.loginTypeId = loginTypeId;
  },
  SET_TEMP_TOKEN: (state, tempToken) => {
    state.tempToken = tempToken;
  },
  SET_MARKETAPI:(state, marketApi) =>{
    state.marketApi = marketApi;
  },
  LOADING: (state, isLoading) => {
    if (isLoading) {
      state.refCount++;
      state.isLoading = true;
    } else if (state.refCount > 0) {
      state.refCount--;
      state.isLoading = (state.refCount > 0);
    }
  },
  SET_PRODUCTLIST: (state, productList) => {
    state.productList = productList;
  },
  SET_CMSTYPE: (state, ccmsType) => {
    state.ccmsType = ccmsType;
  },
  SET_BBPSBOUKEY1LABEL: (state, bbpsBouKey1Label) => {
    state.bbpsBouKey1Label = bbpsBouKey1Label;
  },
  SET_BBPSBOU_BILLERTYPEID: (state, billerTypeId) => {
    state.billerTypeId = billerTypeId;
  },
  
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { mobileNo, password, _csrf } = userInfo;
    return new Promise((resolve, reject) => {
      login({ mobileNo: mobileNo.trim(), password }).then((response) => {
        const { data } = response;
        if (data.typeId == 1) {
          commit('SET_ACCESS_TOKEN', data.accessToken);
          commit('SET_LOGIN_TYPEID', data.typeId);
          // commit('SET_REFRESH_TOKEN', data.refreshToken);
          setAccessToken(data.accessToken);

          setLoginTypeId(data.typeId);
          // setRefreshToken(data.refreshToken);
        } else if (data.typeId == 2) {
          commit('SET_TEMP_TOKEN', data.tempToken);
          commit('SET_LOGIN_TYPEID', data.typeId);
          // commit('SET_REFRESH_TOKEN', data.refreshToken);
          setTempToken(data.tempToken);

          setLoginTypeId(data.typeId);
        // setRefreshToken(data.refreshToken);
        }

        resolve();
      }).catch((error) => {
        reject(error);
      });
    });
  },
  // verify login
  loginstep2({ commit }, userInfo) {
    const { tempToken, totp } = userInfo;
    return new Promise((resolve, reject) => {
      loginStep2({ tempToken, totp }).then((response) => {
        const { data } = response;

        commit('SET_ACCESS_TOKEN', data.accessToken);

        setAccessToken(data.accessToken);

        commit('SET_TEMP_TOKEN', '');
        commit('SET_LOGIN_TYPEID', '');

        removeLoginTypeId();
        removeTempToken();
        resolve();
      }).catch((error) => {
        reject(error);
      });
    });
  },
  // get user info
  getInfo({ commit }, accIndex) {
    return new Promise((resolve, reject) => {
      commit('SET_ACCOUNTINDEX', accIndex);

      getInfo(state.accessToken).then((response) => {

        const { data } = response;


        const {
          name, roleIds, _id, accountId, defaultMonth, disableMonths, accountNames, productList,policy
        } = data;

        commit('SET_NAME', `${accountNames[accIndex]} / ${name}`);
        commit('SET_ROLE', roleIds);
        commit('SET_DYNAMICQR', accountId.upiEnableDynamicQR ? accountId.upiEnableDynamicQR :false);
        commit('SET_AUTOCOMPLETE', accountId.enableAutocomplete ? accountId.enableAutocomplete :false);
        commit('SET_LOGINID', _id);
        
        commit('SET_ISONDEMANDSETTLEMENTFILE', accountId.payoutFileUpload ? accountId.payoutFileUpload : false);
        commit('SET_ISPAYOUTV2FILE', accountId.payoutv2FileUpload ? accountId.payoutv2FileUpload : false);
        commit('SET_MARKETAPI',accountId.apiAccess.marketApi?accountId.apiAccess.marketApi:false);
        commit('SET_ACTIVE_MODEL_CODE', productList[0].productCode);

        // commit('SET', 1);
        // }
        commit('SET_ACCOUNTID', accountId._id);
        commit('SET_DEFAULTMONTH', defaultMonth);
        commit('SET_POLICY', policy);
        commit('SET_DISABLEMONTHS', disableMonths);
        commit('SET_ISCUSENABLED', accountId.configurations.customerIdentification.enabled);
        commit('SET_CUSLABELID', accountId.configurations.customerIdentification.IdLabel ? accountId.configurations.customerIdentification.IdLabel : 'Customer No.');
        commit('SET_CUSLABELNAME', accountId.configurations.customerIdentification.NameLabel ? accountId.configurations.customerIdentification.NameLabel : 'Customer Name');
        commit('SET_ISAMOUNT', accountId.isCollectAmount);
        commit('SET_SETTLEMENT_TYPEID', accountId.settlementTypeId);
        commit('SET_ACCOUNTNAMES', accountNames);
        commit('SET_PRODUCTLIST', productList);
        commit('SET_CMSTYPE', accountId.ccmsType);
        commit('SET_BBPSBOUKEY1LABEL', accountId.bbpsKey1Label);
        commit('SET_BBPSBOU_BILLERTYPEID', accountId.billerTypeId);
        

        setProductList(productList);
        setActiveModel(productList[0].productCode);
        setAccountIndex(accIndex);
        resolve(data);
      }).catch((error) => {
        reject(error);
      });
    });
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_ACCESS_TOKEN', '');
        commit('SET_NAME', '');
        commit('SET_ROLE', []);
        commit('SET_DYNAMICQR', '');
        commit('SET_AUTOCOMPLETE', '');
        // commit('SET_REFRESH_TOKEN', '');
        commit('SET_LOGINID', '');
        commit('SET_ACCOUNTID', '');
        commit('SET_DEFAULTMONTH', '');
        commit('SET_POLICY', '');
        commit('SET_DISABLEMONTHS', '');
        commit('SET_ISCUSENABLED', false);
        commit('SET_CUSLABELID', '');
        commit('SET_CUSLABELNAME', '');
        commit('SET_ISAMOUNT', false);
        commit('SET_ACCOUNTNAMES', []);
        commit('SET_TEMP_TOKEN', '');
        commit('SET_LOGIN_TYPEID', '');
        commit('SET_PRODUCTLIST', []);
        commit('SET_CMSTYPE', '');
        commit('SET_BBPSBOUKEY1LABEL','');
        commit('SET_BBPSBOU_BILLERTYPEID', '');
        removeLoginTypeId();
        removeTempToken();
        // removeRefreshToken();
        removeAccessToken();
        removeAccountIndex();
        removeProductList();
        removeActiveModel();
        resolve();
      }).catch((error) => {
        reject(error);
      });
    });
  },
  clearUserData({ commit }) {
    return new Promise((resolve) => {
      commit('SET_ACCESS_TOKEN', '');
      commit('SET_NAME', '');
      commit('SET_ROLE', []);
      commit('SET_DYNAMICQR', '');
      commit('SET_AUTOCOMPLETE', '');
      // commit('SET_REFRESH_TOKEN', '');
      commit('SET_LOGINID', '');
      commit('SET_ACCOUNTID', '');
      commit('SET_DEFAULTMONTH', '');
      commit('SET_POLICY', '');
      commit('SET_DISABLEMONTHS', '');
      commit('SET_ISCUSENABLED', false);
      commit('SET_CUSLABELID', '');
      commit('SET_CUSLABELNAME', '');
      commit('SET_ISAMOUNT', false);
      commit('SET_ACCOUNTNAMES', []);
      commit('SET_TEMP_TOKEN', '');
      commit('SET_LOGIN_TYPEID', '');
      commit('SET_PRODUCTLIST', []);
      commit('SET_CMSTYPE', '');
      commit('SET_BBPSBOUKEY1LABEL','');
      commit('SET_BBPSBOU_BILLERTYPEID', '');
      removeLoginTypeId();
      removeTempToken();
      // removeRefreshToken();
      removeAccessToken();
      removeAccountIndex();
      removeProductList();
      removeActiveModel();
      resolve();
    });
  },
  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      commit('SET_ACCESS_TOKEN', '');
      // commit('SET_REFRESH_TOKEN', '');
      // removeRefreshToken();
      removeAccessToken();
      resolve();
    });
  },

  changeModel({ commit }, activeModelCode) {
    return new Promise((resolve) => {
      setActiveModel(activeModelCode);
      commit('SET_ACTIVE_MODEL_CODE', activeModelCode);
      resolve();
    });
  },
  // refreshToken({ commit }) {
  //   return new Promise((resolve, reject) => {
  //     refresh().then((response) => {
  //       const { data } = response;
  //       commit('SET_ACCESS_TOKEN', data.accessToken);
  //       // commit('SET_REFRESH_TOKEN', data.refreshToken);
  //       setAccessToken(data.accessToken);
  //       resolve();
  //     }).catch((error) => {
  //       reject(error);
  //     });
  //   });
  // },
  enableLoading({ commit }) {
    return new Promise((resolve) => {
      commit('LOADING', true);
      resolve();
    });
  },
  disableLoading({ commit }) {
    return new Promise((resolve) => {
      commit('LOADING', false);
      resolve();
    });
  },

  setCsrfToken({ commit }, csrfToken) {
    return new Promise((resolve) => {
      commit('SET_CSRF_TOKEN', csrfToken);
      resolve();
    });
  },
  initCsrfToken({ commit }) {
    return new Promise((resolve, reject) => {
      getCsrfToken().then((response) => {
        resolve();
      }).catch((error) => {
        reject(error);
      });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
